import React from "react";

export default function NoMatch() {
  return (
    <div className="h-screen flex items-center justify-center">
      <h1 className="text-4xl">404 Not Found</h1>
    </div>
  );
}
